module.exports = __webpack_public_path__ + "static/AboutUs-Vision-Graphics_v1-2ada84a3f16796f9d2499c50295fb524.svg";